function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { nanoid } from 'nanoid';
const ProphecyErrorCode = nanoid();
export class ProphecyError extends Error {
    getStack() {
        return this.stack || this._stack;
    }
    constructor(message, options){
        super(message, options), _define_property(this, "cause", void 0), _define_property(this, "_stack", void 0);
        this._stack = this.stack;
        this.stack = undefined;
        this.cause = (options === null || options === void 0 ? void 0 : options.cause) || ProphecyErrorCode;
    }
}
export const prophecyErrorToError = (error)=>{
    const newErr = new Error(error.message, {
        cause: error.cause
    });
    newErr.stack = error.getStack ? error.getStack() : error.stack;
    return newErr;
};
export const isProphecyError = (error)=>{
    return error instanceof ProphecyError || error instanceof Error;
};
export const isAbortError = (error)=>{
    return error instanceof DOMException && error.name === 'AbortError';
};
